import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import { Col, Container, Row } from 'reactstrap';

const Referrals = () => {
  const { t, ready } = useTranslation(['global', 'notifications']);

  useEffect(() => {
    // Dynamically load the Viral Loops script
    const script = document.createElement('script');
    script.src = 'https://app.viral-loops.com/widgetsV2/core/loader.js';
    script.type = 'text/javascript';
    script.id = 'viral-loops-loader';
    script.dataset.campaignId = 'Mef8ixw3qpfLv3C3GoTR3qOBw9E';
    document.body.appendChild(script);

    // Cleanup the script when the component unmounts
    return () => {
      document.body.removeChild(script);
      // Optionally, remove any leftover widgets or data attributes from the DOM
      const formWidget = document.querySelector('form-widget');
      const rewardsWidget = document.querySelector('rewards-widget');
      if (formWidget) formWidget.remove();
      if (rewardsWidget) rewardsWidget.remove();
    };
  }, []);

  if (!ready) return null;

  return (
    <>
      <Header activeLocation={'referrals'} />
      <Container className={'mt-lg--5 mt-md--5 mt-sm--3 mt--3'} fluid>
        <Row className="p-0 m-0">
          <Col className="col-6">
            <form-widget ucid="Mef8ixw3qpfLv3C3GoTR3qOBw9E"></form-widget>
          </Col>
          <Col className="col-6">
            <rewards-widget ucid="Mef8ixw3qpfLv3C3GoTR3qOBw9E"></rewards-widget>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Referrals;
